"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Cell = _interopRequireDefault(require("../Cell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\ttext-align: left;\n\tfont-family: 'galano-bold', sans-serif;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var HeaderCell = (0, _styledComponents.default)(_Cell.default.withComponent('th'))(_templateObject());
HeaderCell.displayName = 'HeaderCell';
/* @component */

var _default = HeaderCell;
exports.default = _default;